import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from './root'

const BtiSports = lazyRouteComponent(() => import('../pages/sports/bti-sports'))

export const btiSportsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sports',
  component: BtiSports,
  validateSearch: (search: Record<string, unknown>): { eventId?: string } => ({
    eventId: typeof search.eventId === 'string' ? search.eventId : undefined,
  }),
})
